import CalendarIcon from "@diligentcorp/atlas-react-icons/Calendar.js";
import ExpandDownIcon from "@diligentcorp/atlas-react-icons/ExpandDown.js";
import ExpandLeftIcon from "@diligentcorp/atlas-react-icons/ExpandLeft.js";
import ExpandRightIcon from "@diligentcorp/atlas-react-icons/ExpandRight.js";
const getDatePickerTokens = (tokens) => {
    return {
        datePicker: tokens.component.datePicker,
        semantic: tokens.semantic,
        button: tokens.component.button,
    };
};
export const datePicker = (tokens) => {
    const { datePicker, semantic, button } = getDatePickerTokens(tokens);
    return {
        MuiCalendarPicker: {
            styleOverrides: {
                root: {
                    background: datePicker.day.selected.backgroundColor.value,
                    color: datePicker.header.color.value,
                    borderRadius: datePicker.borderRadius.value,
                    width: "auto",
                    padding: 0,
                    margin: 0,
                    overflowY: "hidden",
                    svg: {
                        color: datePicker.header.color.value,
                    },
                    "> div:first-of-type": {
                        margin: 0,
                        paddingBottom: datePicker.header.paddingBottom.value,
                        // We're intentionally using paddingBottom here to center the header,
                        // as the design as described by tokens is not fully implementable with MUI.
                        paddingTop: datePicker.header.paddingBottom.value,
                        paddingLeft: datePicker.header.paddingHorizontal.value,
                        paddingRight: datePicker.header.paddingHorizontal.value,
                        maxHeight: "unset",
                        minHeight: "unset",
                        "& .MuiButtonBase-root": {
                            width: button.iconOnly.width.value,
                            height: button.height.value,
                            "& svg": {
                                width: semantic.iconSize.lg.value,
                                height: semantic.iconSize.lg.value,
                                fontSize: semantic.iconSize.lg.value,
                            },
                        },
                        "> div": {
                            minHeight: "unset",
                            maxHeight: button.height.value,
                            overflow: "visible",
                        },
                    },
                    "& .MuiYearPicker-root, .MuiMonthPicker-root": {
                        color: semantic.color.text.body.value,
                    },
                    "& .PrivatePickersYear-yearButton, .PrivatePickersMonth-root": {
                        borderRadius: datePicker.day.borderRadius.value,
                        fontSize: datePicker.day.fontSize.value,
                        "&.Mui-selected": {
                            borderRadius: datePicker.day.borderRadius.value,
                        },
                        '&[aria-current="date"]': {
                            border: `${semantic.borderWidth.thin.value} solid ${datePicker.day.today.borderColor.value}`,
                        },
                        "&:hover": {
                            backgroundColor: semantic.color.transparent.hover.value,
                        },
                        "&:focus": {
                            boxShadow: semantic.shadow.focus.value.stringValue,
                            // To comply with WCAG, the focus ring must fully surround the element.
                            // There is no spacing between the items in the calendar picker,
                            // so we need to elevate the focused item above the others.
                            zIndex: 1,
                        },
                    },
                    "& .MuiDayPicker-header, & .MuiMonthPicker-root": {
                        paddingTop: datePicker.calendar.padding.value,
                    },
                },
                viewTransitionContainer: {
                    background: datePicker.backgroundColor.value,
                    overflowY: "scroll",
                    ".MuiTypography-caption": {
                        color: datePicker.week.color.value,
                        fontSize: datePicker.week.fontSize.value,
                    },
                },
            },
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    borderRadius: datePicker.day.borderRadius.value,
                    backgroundColor: datePicker.backgroundColor.value,
                    fontSize: datePicker.day.fontSize.value,
                    transition: "none !important",
                    "&.MuiPickersDay-today": {
                        backgroundColor: "unset",
                        transition: "none !important",
                    },
                    "&.Mui-selected": {
                        backgroundColor: datePicker.day.selected.backgroundColor.value,
                    },
                    "&:not(.Mui-selected)": {
                        borderColor: datePicker.day.today.borderColor.value,
                        "&:hover": {
                            backgroundColor: semantic.color.transparent.hover.value,
                        },
                    },
                    "&:focus": {
                        boxShadow: semantic.shadow.focus.value.stringValue,
                        zIndex: 1,
                    },
                },
            },
        },
        MuiDateRangePickerDay: {
            styleOverrides: {
                root: {
                    "&:last-of-type": {
                        borderTopRightRadius: "0",
                        borderBottomRightRadius: "0",
                    },
                    "&:first-of-type": {
                        borderTopLeftRadius: "0",
                        borderBottomLeftRadius: "0",
                    },
                },
            },
        },
        MuiDatePicker: {
            defaultProps: {
                components: {
                    OpenPickerIcon: CalendarIcon,
                    LeftArrowIcon: ExpandLeftIcon,
                    RightArrowIcon: ExpandRightIcon,
                    SwitchViewIcon: ExpandDownIcon,
                },
                PaperProps: {
                    sx: {
                        boxShadow: datePicker.boxShadow.value.stringValue,
                    },
                },
            },
        },
        MuiStaticDatePicker: {
            defaultProps: {
                components: {
                    LeftArrowIcon: ExpandLeftIcon,
                    RightArrowIcon: ExpandRightIcon,
                    SwitchViewIcon: ExpandDownIcon,
                },
            },
        },
        MuiPickersArrowSwitcher: {
            styleOverrides: {
                root: {
                    background: datePicker.day.selected.backgroundColor.value,
                    color: datePicker.header.color.value,
                    svg: {
                        color: datePicker.header.color.value,
                    },
                    "& .MuiButtonBase-root": {
                        width: button.iconOnly.width.value,
                        height: button.iconOnly.width.value,
                        "& svg": {
                            width: semantic.iconSize.lg.value,
                            height: semantic.iconSize.lg.value,
                            fontSize: semantic.iconSize.lg.value,
                        },
                        "&.Mui-disabled svg": {
                            color: datePicker.header.controls.disabled.color.value,
                        },
                    },
                },
            },
        },
    };
};
export default datePicker;
//# sourceMappingURL=datePicker.js.map